import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";

export default function FieldTotal_ViewSmall(props:FieldViewSmallProps) {

    const value = props.field.getViewValue(props.model)

    if (_.isNil(value)) return false

    const icon = _.get(props.field.components, 'ValueIcon', false)

    if (!icon) return <div className="ui5-txt-less-important-small txt-truncate">{value}</div>;

    if (icon) {
        return (
            <React.Fragment>
                {icon}
                <div className="ui5-txt-less-important-small txt-truncate">{value}</div>
            </React.Fragment>
        )
    }
}
